import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { keyframes } from '@emotion/react';

const pulse = keyframes`
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
`;

export default function AppLoadingSpinner () {

     const theme = useTheme();
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        gap: 2,
        p: 3,
        textAlign: 'center'
      }}
    >
      <CircularProgress 
        size={60} 
        thickness={4}
        sx={{
          color: theme.palette.primary.main,
          animation: `${pulse} 1.5s ease-in-out infinite`
        }} 
      />
      
      <Typography 
        variant="h6" 
        component="div"
        sx={{
          color: theme.palette.text.primary,
          animation: `${pulse} 1.5s ease-in-out infinite`,
          fontWeight: 500
        }}
      >
        Loading your data...
      </Typography>
      
      <Typography 
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          maxWidth: '300px'
        }}
      >
        Please wait while we prepare your personalised experience
      </Typography>
    </Box>
  );
}